/** Surfaces that can create a time entry (stored on `TimeEntry.entryMethod`). */
export const TIME_ENTRY_METHODS = [
    'timesheet',
    'project_portal',
    'ticket_portal',
    'connectwise',
];
export const TIME_ENTRY_METHOD_LABELS = {
    timesheet: 'Timesheet (PSA)',
    project_portal: 'Public project link',
    ticket_portal: 'Public ticket link',
    connectwise: 'ConnectWise sync',
};
//# sourceMappingURL=time-entry.js.map